// extracted by mini-css-extract-plugin
export var dividerContainer = "_8g-0";
export var line = "_8g-1";